export const en = (__LOCALE_EN__ ? ({
  breadcrumbs: {
    cards: 'Card index and lists',
    card_page: 'Person card',
  },
  page_title: 'Person card: {{fio}}',
  buttons: {
    'search by external id': {
      label: 'Search person',
    },
    'delete file': {
      tooltip: 'Delete file',
    },
    'download file': {
      tooltip: 'Download file',
    },
    'attach card to list': {
      tooltip: 'Attach to list',
    },
  },
  delete: {
    last_face: {
      title: 'Removing the last person',
      message: 'The card will be unpinned from the lists. Are you sure?',
    },
    list: {
      title: 'Exclude from list',
      message: 'Are you sure you want to exclude the card from the list {{listName}}?',
    },
  },
  empty: {
    no_faces: 'No data. Add faces.',
  },
  'face card': {
    buttons: {
      'face search button': {
        label: 'Search',
      },
    },
  },
  info: {
    'no data': 'No data',
  },
  'info block': {
    title: 'Common information',
    'card id': 'Card ID',
    fio: 'Full name',
    'date created': 'Date created',
  },
  'edit card': {
    title: 'Edit card',
    'input label': 'Full name',
    toast: {
      success: 'Card was successfully updated',
    },
  },
  filters: {
    popovers: {
      date: {
        label: 'Creation date',
      },
      'face ids': {
        label: 'Face IDs',
      },
      'user data': {
        label: 'User data',
      },
    },
    buttons: {
      'reset button': {
        label: 'Reset',
      },
    },
  },
  features: {
    'verify face': {
      modal: {
        title: 'Compare faces',
        buttons: {
          verify: {
            label: 'Compare',
          },
          clear: {
            label: 'Clear',
          },
        },
      },
      'verify button': {
        label: 'Compare',
      },
    },
    attach_card_to_list: {
      title: 'Lists',
    },
    upload_file_form: {
      title: 'Add file',
      fields: {
        file: 'File',
        name: 'Name',
      },
      actions: {
        submit: 'Save',
        cancel: 'Cancel',
      },
    },
    person_files: {
      title: 'Files',
      empty: 'No data',
    },
  },
}) : {}) as Record<string, unknown>;
export const ru = (__LOCALE_RU__ ? ({
  breadcrumbs: {
    cards: 'Картотека и списки',
    card_page: 'Карточка персоны',
  },
  page_title: 'Карточка персоны: {{fio}}',
  buttons: {
    'search by external id': {
      label: 'Искать персону',
    },
    'delete file': {
      tooltip: 'Удалить файл',
    },
    'download file': {
      tooltip: 'Скачать файл',
    },
    'attach card to list': {
      tooltip: 'Прикрепить к списку',
    },
  },
  delete: {
    last_face: {
      title: 'Удаление последнего лица',
      message: 'Карточка будет откреплена от списков. Вы уверены?',
    },
    list: {
      title: 'Исключить из списка',
      message: 'Вы уверены, что хотите исключить карточку из списка {{listName}}?',
    },
  },
  empty: {
    no_faces: 'Нет данных. Добавьте лица.',
  },
  'face card': {
    buttons: {
      'face search button': {
        label: 'Искать',
      },
    },
  },
  info: {
    'no data': 'Нет данных',
  },
  'info block': {
    title: 'Общая информация',
    'card id': 'ID карточки',
    fio: 'ФИО',
    'date created': 'Создано',
  },
  'edit card': {
    title: 'Редактировать карточку',
    'input label': 'ФИО',
    toast: {
      success: 'Карточка успешно обновлена',
    },
  },
  filters: {
    popovers: {
      date: {
        label: 'Дата создания',
      },
      'face ids': {
        label: 'ID лиц',
      },
      'user data': {
        label: 'Информация',
      },
    },
    buttons: {
      'reset button': {
        label: 'Очистить',
      },
    },
  },
  features: {
    'verify face': {
      modal: {
        title: 'Сравнить лица',
        buttons: {
          verify: {
            label: 'Сравнить',
          },
          clear: {
            label: 'Очистить',
          },
        },
      },
      'verify button': {
        label: 'Сравнить',
      },
    },
    attach_card_to_list: {
      title: 'Списки',
    },
    upload_file_form: {
      title: 'Добавить файл',
      fields: {
        file: 'Файл',
        name: 'Название',
      },
      actions: {
        submit: 'Сохранить',
        cancel: 'Отмена',
      },
    },
    person_files: {
      title: 'Файлы',
      empty: 'Нет данных',
    },
  },
}) : {}) as Record<string, unknown>;
